<template>
  <div class="hongyun-page">
    <!-- 页面标题 -->
    <div class="page-header">
      <div class="container">
        <h1>HONG云</h1>
        <p>企业云服务平台</p>
      </div>
    </div>

    <!-- 产品概述 -->
    <section class="product-overview">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <img 
              src="../assets/images/hongyun.7412facc.gif" 
              alt="HONG云平台" 
              class="overview-img img-fluid"
            >
          </div>
          <div class="col-md-6">
            <div class="overview-content">
              <h2>产品概述</h2>
              <p>HONG云是禾苗自主研发的企业级云服务平台，为企业提供稳定、安全、高效的云端解决方案。通过整合计算、存储、网络等基础资源，以及丰富的企业级应用服务，帮助企业快速构建数字化基础设施，加速业务创新。</p>
              <div class="overview-highlights">
                <div class="highlight-item">
                  <div class="highlight-number">01</div>
                  <div class="highlight-text">
                    <h4>灵活扩展</h4>
                    <p>根据业务需求弹性扩展资源，避免资源浪费</p>
                  </div>
                </div>
                <div class="highlight-item">
                  <div class="highlight-number">02</div>
                  <div class="highlight-text">
                    <h4>安全可靠</h4>
                    <p>多重安全防护，保障企业数据安全</p>
                  </div>
                </div>
                <div class="highlight-item">
                  <div class="highlight-number">03</div>
                  <div class="highlight-text">
                    <h4>成本可控</h4>
                    <p>按需付费，降低企业IT基础设施投入</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 核心服务 -->
    <section class="core-services">
      <div class="container">
        <div class="section-header text-center">
          <h2>核心服务</h2>
          <p>为企业提供全方位的云服务解决方案</p>
        </div>
        <div class="row service-grid">
          <div class="col-md-4">
            <div class="service-card">
              <div class="service-icon">
                <img src="../assets/images/1.670c7eef.gif" alt="云计算">
              </div>
              <h3>云计算</h3>
              <p>提供弹性计算服务，包括云服务器、容器服务、函数计算等，满足企业不同业务场景的计算需求。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="service-card">
              <div class="service-icon">
                <img src="../assets/images/2.0a9650a7.gif" alt="云存储">
              </div>
              <h3>云存储</h3>
              <p>提供对象存储、块存储、文件存储等多种存储服务，支持海量数据存储，确保数据安全可靠。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="service-card">
              <div class="service-icon">
                <img src="../assets/images/exp.595da4b7.gif" alt="云数据库">
              </div>
              <h3>云数据库</h3>
              <p>提供MySQL、MongoDB、Redis等多种数据库服务，具备高可用、高性能、可扩展的特性。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="service-card">
              <div class="service-icon">
                <img src="../assets/images/banner.png" alt="云安全">
              </div>
              <h3>云安全</h3>
              <p>提供DDoS防护、Web应用防火墙、数据加密、身份认证等全方位安全服务。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="service-card">
              <div class="service-icon">
                <img src="../assets/images/hemiao.aafbc56b.gif" alt="云网络">
              </div>
              <h3>云网络</h3>
              <p>提供VPC、负载均衡、CDN、专线接入等网络服务，构建安全、高效的网络环境。</p>
            </div>
          </div>
          <div class="col-md-4">
            <div class="service-card">
              <div class="service-icon">
                <img src="../assets/images/hongyun-mobile.78df8849.gif" alt="云监控">
              </div>
              <h3>云监控</h3>
              <p>提供全面的监控告警服务，实时监控资源状态，保障业务稳定运行。</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 解决方案 -->
    <section class="solutions">
      <div class="container">
        <div class="section-header text-center">
          <h2>行业解决方案</h2>
          <p>针对不同行业提供定制化的云服务解决方案</p>
        </div>
        <div class="row solution-list">
          <div class="col-md-6">
            <div class="solution-card">
              <div class="solution-header">
                <img 
                  src="../assets/images/hongyun.7412facc.gif" 
                  alt="互联网行业" 
                  class="solution-img img-fluid"
                >
                <div class="solution-overlay">
                  <h3>互联网行业</h3>
                </div>
              </div>
              <div class="solution-content">
                <p>为互联网企业提供高可用、高性能的云服务基础设施，支持业务快速迭代和弹性扩展，满足突发流量需求。</p>
                <a href="#" class="solution-link">了解更多 →</a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="solution-card">
              <div class="solution-header">
                <img 
                  src="../assets/images/ai.f04e201c.gif" 
                  alt="金融行业" 
                  class="solution-img img-fluid"
                >
                <div class="solution-overlay">
                  <h3>金融行业</h3>
                </div>
              </div>
              <div class="solution-content">
                <p>符合金融行业监管要求的云服务解决方案，提供高安全、高合规的服务，保障金融业务稳定运行。</p>
                <a href="#" class="solution-link">了解更多 →</a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="solution-card">
              <div class="solution-header">
                <img 
                  src="../assets/images/hemiao.aafbc56b.gif" 
                  alt="教育行业" 
                  class="solution-img img-fluid"
                >
                <div class="solution-overlay">
                  <h3>教育行业</h3>
                </div>
              </div>
              <div class="solution-content">
                <p>为教育机构提供在线教育平台、校园信息化建设等解决方案，支持远程教学和资源共享。</p>
                <a href="#" class="solution-link">了解更多 →</a>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="solution-card">
              <div class="solution-header">
                <img 
                  src="../assets/images/banner.png" 
                  alt="医疗行业" 
                  class="solution-img img-fluid"
                >
                <div class="solution-overlay">
                  <h3>医疗行业</h3>
                </div>
              </div>
              <div class="solution-content">
                <p>为医疗机构提供医疗云平台、电子病历系统等解决方案，保障医疗数据安全，提升医疗服务效率。</p>
                <a href="#" class="solution-link">了解更多 →</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 技术架构 -->
    <section class="tech-architecture">
      <div class="container">
        <div class="section-header text-center">
          <h2>技术架构</h2>
          <p>先进的技术架构，确保平台稳定高效运行</p>
        </div>
        <div class="architecture-diagram">
          <img 
            src="../assets/images/hongyun.7412facc.gif" 
            alt="技术架构图" 
            class="img-fluid"
          >
        </div>
        <div class="architecture-features">
          <div class="row">
            <div class="col-md-3">
              <div class="feature-item">
                <h4>分布式架构</h4>
                <p>采用微服务架构，服务独立部署，支持弹性扩展</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="feature-item">
                <h4>高可用设计</h4>
                <p>多可用区部署，自动故障转移，保障服务连续性</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="feature-item">
                <h4>数据安全</h4>
                <p>多层加密机制，数据备份恢复，确保数据安全</p>
              </div>
            </div>
            <div class="col-md-3">
              <div class="feature-item">
                <h4>性能优化</h4>
                <p>智能调度，资源优化，提升系统性能</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 客户案例 -->
    <section class="customer-cases">
      <div class="container">
        <div class="section-header text-center">
          <h2>客户案例</h2>
          <p>成功案例展示</p>
        </div>
        <div class="row case-list">
          <div class="col-md-4">
            <div class="case-card">
              <div class="case-header">
                <div class="case-company">某知名电商平台</div>
              </div>
              <div class="case-content">
                <h3>挑战</h3>
                <p>电商促销期间流量激增，传统IT架构无法支撑业务需求</p>
                <h3>解决方案</h3>
                <p>采用HONG云弹性计算服务，实现按需扩容，保障业务稳定</p>
                <h3>成果</h3>
                <p>成功应对流量峰值，系统可用性达99.99%，IT成本降低40%</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="case-card">
              <div class="case-header">
                <div class="case-company">某金融科技公司</div>
              </div>
              <div class="case-content">
                <h3>挑战</h3>
                <p>数据安全合规要求高，需要高性能、高安全的IT基础设施</p>
                <h3>解决方案</h3>
                <p>采用HONG云金融专区服务，满足合规要求，保障数据安全</p>
                <h3>成果</h3>
                <p>顺利通过监管审查，业务处理效率提升60%，客户满意度提高</p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="case-card">
              <div class="case-header">
                <div class="case-company">某教育培训机构</div>
              </div>
              <div class="case-content">
                <h3>挑战</h3>
                <p>疫情期间线上教学需求激增，现有系统无法满足需求</p>
                <h3>解决方案</h3>
                <p>快速部署HONG云在线教育解决方案，支持大规模并发访问</p>
                <h3>成果</h3>
                <p>支持10万学生同时在线学习，系统稳定运行，教学质量得到保障</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 服务支持 -->
    <section class="service-support">
      <div class="container">
        <div class="section-header text-center">
          <h2>服务支持</h2>
          <p>7×24小时专业技术支持，为您的业务保驾护航</p>
        </div>
        <div class="support-grid">
          <div class="support-item">
            <div class="support-icon">
              <i class="iconfont icon-clock"></i>
            </div>
            <h3>7×24小时支持</h3>
            <p>全天候技术支持，随时解决您的问题</p>
          </div>
          <div class="support-item">
            <div class="support-icon">
              <i class="iconfont icon-shield"></i>
            </div>
            <h3>安全保障</h3>
            <p>多重安全防护，保障业务稳定运行</p>
          </div>
          <div class="support-item">
            <div class="support-icon">
              <i class="iconfont icon-book"></i>
            </div>
            <h3>专业服务</h3>
            <p>专业的技术团队，提供定制化服务</p>
          </div>
          <div class="support-item">
            <div class="support-icon">
              <i class="iconfont icon-trophy"></i>
            </div>
            <h3>服务承诺</h3>
            <p>SLA服务等级承诺，保障服务质量</p>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Hongyun'
}
</script>

<style scoped>
.hongyun-page {
  min-height: 100vh;
}

/* 页面标题 */
.page-header {
  background: linear-gradient(135deg, #6c5ce7 0%, #5f3dc4 100%);
  color: white;
  padding: 5rem 0;
  text-align: center;
}

.page-header h1 {
  font-size: 3rem;
  margin-bottom: 1rem;
  font-weight: 600;
}

.page-header p {
  font-size: 1.5rem;
  opacity: 0.9;
}

/* 产品概述 */
.product-overview {
  padding: 5rem 0;
}

.overview-img {
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.overview-content {
  padding: 2rem;
}

.overview-content h2 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1.5rem;
}

.overview-content p {
  font-size: 1.1rem;
  color: #666;
  line-height: 1.8;
  margin-bottom: 2rem;
}

.overview-highlights {
  margin-top: 2rem;
}

.highlight-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 2rem;
}

.highlight-number {
  font-size: 2rem;
  color: #6c5ce7;
  font-weight: bold;
  margin-right: 1.5rem;
  line-height: 1;
}

.highlight-text h4 {
  font-size: 1.25rem;
  color: #333;
  margin-bottom: 0.5rem;
}

.highlight-text p {
  color: #666;
  margin-bottom: 0;
  line-height: 1.6;
}

/* 核心服务 */
.core-services {
  padding: 5rem 0;
  background-color: #f8f9fa;
}

.section-header {
  margin-bottom: 3rem;
}

.section-header h2 {
  font-size: 2.5rem;
  color: #333;
  margin-bottom: 1rem;
  position: relative;
  display: inline-block;
}

.section-header h2::after {
  content: '';
  position: absolute;
  bottom: -10px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background-color: #6c5ce7;
}

.section-header p {
  font-size: 1.2rem;
  color: #666;
  margin-top: 1.5rem;
}

.service-grid {
  margin: 0 -15px;
}

.service-card {
  background-color: white;
  border-radius: 8px;
  padding: 2rem;
  margin-bottom: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  text-align: center;
  height: 100%;
}

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.service-icon {
  margin-bottom: 1.5rem;
}

.service-icon img {
  width: 80px;
  height: 80px;
}

.service-card h3 {
  font-size: 1.5rem;
  color: #333;
  margin-bottom: 1rem;
}

.service-card p {
  color: #666;
  line-height: 1.6;
}

/* 解决方案 */
.solutions {
  padding: 5rem 0;
}

.solution-list {
  margin: 0 -15px;
}

.solution-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  margin-bottom: 2rem;
  height: 100%;
}

.solution-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.solution-header {
  position: relative;
  height: 200px;
  overflow: hidden;
}

.solution-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.solution-card:hover .solution-img {
  transform: scale(1.1);
}

.solution-overlay {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.7), transparent);
  padding: 1.5rem;
}

.solution-overlay h3 {
  color: white;
  font-size: 1.5rem;
  margin: 0;
}

.solution-content {
  padding: 1.5rem;
}

.solution-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1.5rem;
}

.solution-link {
  color: #6c5ce7;
  text-decoration: none;
  font-weight: 500;
  transition: color 0.3s ease;
}

.solution-link:hover {
  color: #5f3dc4;
  text-decoration: underline;
}

/* 技术架构 */
.tech-architecture {
  padding: 5rem 0;
  background-color: #f8f9fa;
}

.architecture-diagram {
  margin-bottom: 3rem;
  text-align: center;
}

.architecture-diagram img {
  max-width: 100%;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.architecture-features {
  margin-top: 2rem;
}

.feature-item {
  text-align: center;
  padding: 1.5rem;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.feature-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.15);
}

.feature-item h4 {
  color: #6c5ce7;
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.feature-item p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 0;
}

/* 客户案例 */
.customer-cases {
  padding: 5rem 0;
}

.case-list {
  margin: 0 -15px;
}

.case-card {
  background-color: white;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  height: 100%;
}

.case-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
}

.case-header {
  background-color: #6c5ce7;
  color: white;
  padding: 1.5rem;
}

.case-company {
  font-size: 1.2rem;
  font-weight: 500;
}

.case-content {
  padding: 1.5rem;
}

.case-content h3 {
  color: #6c5ce7;
  font-size: 1.25rem;
  margin-bottom: 0.5rem;
}

.case-content p {
  color: #666;
  line-height: 1.6;
  margin-bottom: 1rem;
}

/* 服务支持 */
.service-support {
  padding: 5rem 0;
  background-color: #6c5ce7;
  color: white;
}

.service-support .section-header h2 {
  color: white;
}

.service-support .section-header h2::after {
  background-color: white;
}

.service-support .section-header p {
  color: rgba(255, 255, 255, 0.9);
}

.support-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-top: 3rem;
}

.support-item {
  text-align: center;
  padding: 2rem;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: all 0.3s ease;
}

.support-item:hover {
  background-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-10px);
}

.support-icon {
  font-size: 3rem;
  margin-bottom: 1.5rem;
}

.support-item h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.support-item p {
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.6;
  margin-bottom: 0;
}

/* 响应式设计 */
@media (max-width: 767px) {
  .page-header h1 {
    font-size: 2.5rem;
  }
  
  .page-header p {
    font-size: 1.2rem;
  }
  
  .section-header h2 {
    font-size: 2rem;
  }
  
  .section-header p {
    font-size: 1rem;
  }
  
  .overview-content {
    padding: 1rem 0;
  }
  
  .highlight-item {
    flex-direction: column;
    text-align: center;
  }
  
  .highlight-number {
    margin-right: 0;
    margin-bottom: 1rem;
  }
  
  .solution-header {
    height: 150px;
  }
}

@media (max-width: 575px) {
  .page-header {
    padding: 3rem 0;
  }
  
  .page-header h1 {
    font-size: 2rem;
  }
  
  .product-overview,
  .core-services,
  .solutions,
  .tech-architecture,
  .customer-cases,
  .service-support {
    padding: 3rem 0;
  }
}
</style>